// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2uyPb","list":"PatternAutocomplete_list__2sZ_3"};